export default __webpack_public_path__ + "static/media/services_offered.71549f14.png";